<template>
  <main class="flex-1 relative overflow-y-auto focus:outline-none" tabindex="0">
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="md:flex md:items-center md:justify-between">
        <div class="flex min-w-0">
          <svg-vue class="content-title-icon" icon="font-awesome.edit-regular"></svg-vue>
          <h1 class="content-title">
            {{ $t('Edit custom page') }}
          </h1>
        </div>
        <div class="mt-4 flex md:mt-0 md:ml-4">
          <button class="btn btn-red rounded-none rounded-l-md" type="button" @click="deleteCustomPageModal = true">
            {{ $t('Delete') }}
          </button>
          <router-link class="btn btn-app rounded-none rounded-r-md" to="/admin/custom-pages">
            {{ $t('Back') }}
          </router-link>
        </div>
      </div>
    </div>
    <div class="my-6 max-w-1/6 mx-auto px-4 sm:px-6 lg:px-8">
      <div class="content-card-body">
        <loading :status="loading"></loading>
        <form @submit.prevent="updateCustomPage">
          <div class="md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
            <div class="md:col-span-1">
              <h3 class="form-description-head">
                {{ $t('Custom page information') }}
              </h3>
              <p class="form-description-text">{{ $t('Update custom page information and status') }}.</p>
            </div>
            <div class="mt-5 md:mt-0 md:col-span-2">
              <div class="grid grid-cols-3 gap-3">
                <div class="col-span-3">
                  <label class="form-label" for="title">{{ $t('Title') }}</label>
                  <div class="pt-1">
                    <input :placeholder="$t('Title')" class="form-input" id="Title" required v-model="customPage.title" />
                  </div>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="content">{{ $t('Content') }}</label>
                  <input-wysiwyg id="content" v-model="customPage.content"></input-wysiwyg>
                </div>
                <div class="col-span-3">
                  <label class="form-label" for="status">{{ $t('Status') }}</label>
                  <div class="mt-1 flex rounded-md">
                    <input-switch
                      :disabled-label="$t('The page is disabled')"
                      :enabled-label="$t('The page is activated')"
                      id="status"
                      v-model="customPage.status"
                    ></input-switch>
                  </div>
                  <div class="form-description-text">
                    {{ $t('When the page is deactivated, it will not appear on portal') }}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="inline-flex">
              <router-link class="btn btn-secondary shadow-sm rounded-md mr-4" to="/admin/custom-pages">{{ $t('Cancel') }}</router-link>
              <button class="btn btn-app shadow-sm rounded-md" type="submit">
                {{ $t('Update') }}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
    <custom-page-delete-model :show="deleteCustomPageModal" @cancelled="deleteCustomPageModal = false" @confirmed="deleteCustomPage">
      <template #title>{{ $t('Delete custom page') }}</template>
      {{ $t('Are you sure you want to delete the custom page?') }}
      {{ $t('All data will be permanently removed') }}.
    </custom-page-delete-model>
  </main>
</template>
<script>
import confirmationModel from '@/components/layout/admin/confirmation';

export default {
  name: 'edit',
  components: {
    CustomPageDeleteModel: confirmationModel,
  },
  metaInfo() {
    return {
      title: this.$i18n.t('Edit custom page'),
    };
  },
  data() {
    return {
      loading: false,
      deleteCustomPageModal: false,
      customPage: {
        title: null,
        content: null,
        status: false,
      },
    };
  },
  mounted() {
    this.getCustomPage();
  },
  methods: {
    updateCustomPage() {
      this.loading = true;
      axios
        .put(route('custom-pages.update', this.$route.params.id), this.customPage)
        .then((response) => {
          this.loading = false;
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getCustomPage() {
      this.loading = true;
      axios
        .get(route('custom-pages.show', this.$route.params.id))
        .then((response) => {
          this.customPage = response.data;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    deleteCustomPage() {
      axios
        .delete(route('custom-pages.destroy', this.$route.params.id))
        .then((response) => {
          this.$notify({
            title: this.$i18n.t('Success').toString(),
            text: response.data.message.toString(),
            type: 'success',
          });
          this.$router.push('/admin/custom-pages');
        })
        .catch(() => {
          this.deleteCustomPageModal = false;
        });
    },
  },
};
</script>
